import navigation from "@/lang/zu/navigation";
import generics from "@/lang/zu/generics";
import questions from "@/lang/zu/questions";
import a11y from "@/lang/zu/a11y";
import velt from "@/lang/zu/velt";

export default {
  ...navigation,
  ...generics,
  ...questions,
  ...a11y,
  ...velt
}
